var path = 'test-import-drawer/test-import-drawer.html';
var html = "<ns-drawer class=\"ns-grid\" drawer-name=\"test-import-drawer\">\n    <ns-drawer-title>\n        <span>Test Import Results</span>\n    </ns-drawer-title>\n    <ns-drawer-body>\n        <p>Result for your <strong>MOST RECENT</strong> test import completed at {{vm.getTotalSchoolsCompleted()}} schools on {{vm.getTestImportCompletedDate()}}.</p>\n        <ns-table columns=\"vm.columns\" rows=\"vm.rows\" row-height=\"1\" header-height=\"1\"></ns-table>\n    </ns-drawer-body>\n    <ns-drawer-foot>\n        <button class=\"ns-button\" ng-click=\"vm.closeDrawer()\">Close</button>\n    </ns-drawer-foot>\n</ns-drawer>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/test-import-drawer/test-import-drawer.html
// module id = 68
// module chunks = 0